// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore,useAppStore } from '../stores/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginPage.vue')
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/FirstIndexPage.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/supplier',
    name: 'Supplier',
    component: () => import('../views/Supplierdata.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/customer',
    name: 'Customer',
    component: () => import('../views/CustomerPriceask.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/UserManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
{
  path: '/SystemConfig',
  name: 'SystemConfig',
  component: () => import('../views/SystemConfig.vue'),
  meta: { requiresAuth: true, requiresAdmin: true }
}
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// router.beforeEach((to, from, next) => {
//   const appStore = useAppStore()
//   const authStore = useAuthStore()
//   if (to.meta.requiresAuth && !authStore.isLoggedIn) {
//     next('/login')
//   } else if (to.path === '/login' && authStore.isLoggedIn) {
//     next('/dashboard')
//   }else{
//     const routeToMenuMap = {
//     '/dashboard': 'dashboard',
//     '/supplier': 'supplier',
//     '/customer': 'customer',
//     '/users': 'users'
//   }
//   const activeMenu = routeToMenuMap[to.path]
//   if (activeMenu) {
//     appStore.setActiveMenu(activeMenu)
//   }
//   next()
//   }
// })

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // 设置菜单激活状态
  const appStore = useAppStore()
  const routeToMenuMap = {
    '/dashboard': 'dashboard',
    '/supplier': 'supplier',
    '/customer': 'customer',
    '/users': 'users'
  }
  const activeMenu = routeToMenuMap[to.path]
  if (activeMenu) {
    appStore.setActiveMenu(activeMenu)
  }
  
  // 检查是否需要认证
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    next('/login')
  } else if (to.meta.requiresAdmin && authStore.user?.username !== 'admin') {
    next('/dashboard')
  } else {
    next() // 确保只调用一次
  }
})

export default router